import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { AuthenticatedImageComponent } from '../../../../authenticated-image/authenticated-image.component';
import {
  VoucherDesign,
  VoucherDesignService,
} from '../../../../../services/voucher-design.service';

/**
 * The demo voucher on a design, in the page's proportions. The server renders it on
 * first view and caches it; the URL changes with the design and the branding, so a
 * change shows up after the next load.
 */
@Component({
  selector: 'app-design-thumbnail',
  standalone: true,
  imports: [AuthenticatedImageComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
  template: `
    <div
      class="bg-muted relative w-full overflow-hidden rounded border"
      [style.aspect-ratio]="aspectRatio()">
      <app-authenticated-image
        class="absolute inset-0 h-full w-full"
        [src]="src()"
        [retry]="false"
        [alt]="alt()" />
    </div>
  `,
})
export class DesignThumbnailComponent {
  private readonly designService = inject(VoucherDesignService);

  readonly design = input.required<VoucherDesign>();
  readonly alt = input('');

  readonly src = computed(() => this.designService.thumbnailUrl(this.design()));
  /** Width / height of the page, kept between 1:2 and 2:1 so cards stay tidy. */
  readonly aspectRatio = computed(() => {
    const d = this.design();
    const ratio = d.page_width_pt / d.page_height_pt;
    return String(Math.min(Math.max(ratio, 0.5), 2));
  });
}
